import { Elements } from "@ts/core/Elements";
import { AbstractSection } from "./AbstractSection";
import { Utils } from "@ts/core/Utils";

export enum ToolState {
    Normal,
    Active,
    Disabled
}

export class EditTools {

    private section: AbstractSection;
    private toolDiv: HTMLDivElement;

    public constructor(section: AbstractSection) {
        this.section = section;
        this.toolDiv = document.createElement('div');
        this.toolDiv.className = 'editTools';

        Elements.contentContainer.insertBefore(this.toolDiv, section.sectionElementRef);
        this.section.sectionElementRef.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    public get toolElement(): HTMLDivElement { return this.toolDiv; }

    public close(): void {
        if (this.toolDiv && this.toolDiv.parentElement === Elements.contentContainer) {
            Elements.contentContainer.removeChild(this.toolDiv);
        }
    }

    public add(title: string, help: string, action: string, cb: () => void): void {
        const btn = document.createElement('button');
        btn.id = action;
        btn.innerText = title;
        this.toolDiv.appendChild(btn);
        btn.addEventListener('click', (e: Event) => {
            e.preventDefault();
            cb();
        });
        btn.addEventListener('mouseover', (e: Event) => {
            e.preventDefault();
            Elements.help.innerHTML = btn.disabled ? '' : help;
            Elements.help.style.top = `${btn.offsetTop}px`;
            Utils.forceRefresh(Elements.help);
        });
    }

    public setState(action: string, state: ToolState): void {

        const buttons = document.querySelector('.editTools')?.querySelectorAll('button') as NodeListOf<HTMLButtonElement>;
        for (let i = 0; i < buttons.length; i++) {
            const btn = buttons[i];
            if (btn.id === action) {
                switch (state) {
                    case ToolState.Active:
                        btn.disabled = false;
                        btn.classList.remove('disabled');
                        btn.classList.add('active');
                        break;

                    case ToolState.Disabled:
                        btn.disabled = true;
                        btn.classList.remove('active');
                        btn.classList.add('disabled');
                        break;

                    default:
                    case ToolState.Normal:
                        btn.disabled = false;
                        btn.classList.remove('active');
                        btn.classList.remove('disabled');
                        break;
                }
            }
        }
    }

    public getState(action: string): ToolState {
        const buttons = document.querySelector('.editTools')?.querySelectorAll('button') as NodeListOf<HTMLButtonElement>;
        for (let i = 0; i < buttons.length; i++) {
            const btn = buttons[i];
            if (btn.id === action) {
                if (btn.classList.contains('active')) return ToolState.Active;
                if (btn.classList.contains('disabled')) return ToolState.Disabled;
                return ToolState.Normal
            }
        }
        return ToolState.Normal;
    }

    public clearStateAll(): void {
        const buttons = document.querySelector('.editTools')?.querySelectorAll('button') as NodeListOf<HTMLButtonElement>;
        buttons.forEach(m => {
            m.classList.remove('disabled');
            m.classList.remove('active');
        });
    }

    public setStateAll(state: ToolState): void {
        if (state === ToolState.Normal) this.clearStateAll();

        const buttons = document.querySelector('.editTools')?.querySelectorAll('button') as NodeListOf<HTMLButtonElement>;
        buttons.forEach(m => {
            this.setState(m.id, state);
        });
    }


}

export function insertSectionBeforeToolbar(sectionEl: HTMLElement) {
    const page = document.getElementById('page');
    const toolbar = page?.querySelector('.toolbar');

    if (page && toolbar) {
        page.insertBefore(sectionEl, toolbar);
    }
}
